import React from "react";
import { CheckIcon } from "@heroicons/react/24/solid";

const About = () => {
  const features = [
    "Personalized learning approach for each student",
    "Interactive and engaging teaching methods",
    "Focus on practical communication skills",
    "Continuous progress tracking and feedback",
    "Cultural context integration in lessons",
    "Technology-enhanced learning experiences",
  ];

  const skillCards = [
    {
      icon: "📚",
      title: "Curriculum Design",
      desc: "Creating comprehensive learning paths",
      color: "from-blue-50 to-indigo-50",
      iconBg: "bg-blue-600",
    },
    {
      icon: "👥",
      title: "Group Teaching",
      desc: "Interactive classroom experiences",
      color: "from-green-50 to-emerald-50",
      iconBg: "bg-green-600",
    },
    {
      icon: "💡",
      title: "Innovation",
      desc: "Modern teaching techniques",
      color: "from-purple-50 to-violet-50",
      iconBg: "bg-purple-600",
    },
    {
      icon: "❤️",
      title: "Passion",
      desc: "Love for teaching and learning",
      color: "from-orange-50 to-red-50",
      iconBg: "bg-orange-600",
    },
  ];

  return (
    <section id="about" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl lg:text-6xl font-bold font-display mb-6">
            About <span className="gradient-text">Me</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Passionate educator dedicated to transforming English learning
            experiences
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8" data-aos="fade-right">
            <div className="space-y-6">
              <h3
                className="text-3xl font-bold font-display text-gray-800"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                My Teaching Philosophy
              </h3>
              <p
                className="text-gray-600 leading-relaxed font-bangla text-lg"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                আমি বিশ্বাস করি যে প্রতিটি শিক্ষার্থীর নিজস্ব শেখার পদ্ধতি এবং
                গতি রয়েছে। আমার শিক্ষাদান পদ্ধতি ব্যক্তিগতকৃত, ইন্টারঅ্যাক্টিভ
                এবং বাস্তব জীবনের সাথে সম্পর্কিত। আমি প্রতিটি শিক্ষার্থীকে তাদের
                আত্মবিশ্বাস বৃদ্ধি করতে এবং ইংরেজিতে সাবলীলভাবে কথা বলতে সাহায্য
                করি।
              </p>
            </div>

            <div className="space-y-4">
              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4"
                  data-aos="fade-up"
                  data-aos-delay={600 + index * 100}
                >
                  <div className="w-6 h-6 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckIcon className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div
              className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-2xl"
              data-aos="fade-up"
              data-aos-delay="1200"
            >
              <h4 className="text-xl font-bold text-gray-800 mb-3">
                Education & Certifications
              </h4>
              <ul className="space-y-2 text-gray-600">
                <li>• Master's in English Literature - Dhaka University</li>
                <li>• TESOL Certification - Cambridge University</li>
                <li>• IELTS Instructor Training - British Council</li>
                <li>• Digital Teaching Methods Certificate</li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6" data-aos="fade-left">
            {skillCards.map((item, index) => (
              <div
                key={index}
                className={`bg-gradient-to-br ${item.color} p-6 rounded-2xl text-center card-hover`}
                data-aos="zoom-in"
                data-aos-delay={200 + index * 150}
              >
                <div
                  className={`w-16 h-16 ${item.iconBg} rounded-full flex items-center justify-center mx-auto mb-4 text-2xl`}
                >
                  {item.icon}
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">
                  {item.title}
                </h4>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
